module.exports = __webpack_public_path__ + "static/media/cont-webc4f19ca0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/cont-web.svg
// module id = 1227
// module chunks = 0